<template>
  <div class="frame-cliente">
    <financeiros-aberto-cliente ref="financeirosAbertoCliente"/>
    <label>Cliente</label>
    
    <div class="w3-row">
      <div class="w3-col s4 l2">
        <input
          type="text"
          @focus="$event.target.select()"
          @keyup.enter="adicionarPesquisando(false)"
          ref="cliente"
          class="w3-input w3-border input-codigo-cliente"
          v-model="chave_cliente_pesquisa"
          :disabled="!permitido_trocar_cliente"
          v-bind:placeholder="placeholder_codigo"
          @blur.stop="onBlurChave()"
          
          maxlength="15"
        />
      </div>

      <div class="w3-col s8 l10">
        <div class="input-container">
          <input 
            class="input-cliente w3-border" 
            type="text"
            v-model="nome_cliente_exibicao"
            @click="abrir_modal_selecionar_cliente = true"   
            :disabled="!permitido_trocar_cliente"  
            placeholder="Clique aqui para selecionar o cliente"
            readonly>

          <i
            v-if="permitido_trocar_cliente" 
            class="fas fa-minus icone w3-border-top w3-border-right w3-border-bottom" 
            @click="limparDados">
          </i>
        </div>
      </div>
      
      <div v-if="parseFloat(cliente_selecionado.limite_credito_aprovado) > 0">
        <strong 
          v-bind:class="estiloBotaoCredito()" 
          @click="exibirFinanceirosAbertos()">
          Crédito: {{cliente_selecionado.limite_credito_aprovado}} / Disponível: {{cliente_selecionado.limite_credito_disponivel}}
        </strong>
      </div>
    </div>

    <!-- Inicio modal de Cliente  -->
    <div 
      id="modalSelecionarCliente"
      class="w3-modal"
      v-show="abrir_modal_selecionar_cliente"
      @click="abrir_modal_selecionar_cliente = false"
      style="display: block">
      
      <div class="w3-modal-content w3-animate-zoom borda_modal"  @click.stop>
        <header class="w3-container" style="padding:0px!important;">
          <span 
            @click="abrir_modal_selecionar_cliente = false" 
            class="w3-button w3-display-topright">
            &times;
          </span>
            <h4 class="texto-vermelho titulo">Pesquisar Cliente</h4>
        </header>

        <exibir-processando v-if="processando || processando_ver_mais"/>
        
        <div>
          <div
            class="w3-row-padding w3-margin-bottom"
            style="padding:0px!important;"
            v-if="mostrar_filtros_clientes">
            
            <div class="w3-col s12 m12 l12" >
              <label>{{descricaoTipoPesquisa(tipo_pesquisa)}}</label>
              <input 
                v-if="tipo_pesquisa == 'COD'"
                maxlength="60"
                class="w3-input w3-border" 
                style="text-transform: uppercase;" 
                autocomplete="off"
                ref="chave_pesquisa_cliente_ref" 
                type="number" 
                v-model="chave_cliente_pesquisa_modal" 
                id="chave_pesquisa_cliente" 
                v-on:keyup.enter="adicionarClienteVerificandoDados(false)"
                autofocus>

              <input 
                v-if="tipo_pesquisa == 'NOM' || tipo_pesquisa == 'CNP'"
                maxlength="60"
                class="w3-input w3-border" 
                style="text-transform: uppercase" 
                autocomplete="off" 
                ref="chave_pesquisa_cliente_ref" 
                type="text" 
                v-model="chave_cliente_pesquisa_modal" 
                id="chave_pesquisa_cliente" 
                v-on:keyup.enter="adicionarClienteVerificandoDados(false)"
                autofocus>
            </div>   

            <div class="w3-col s12 m12 l12 w3-left w3-margin-top" v-if="ver_apenas_meus_clientes == 'S'">
              <input
                type="checkbox" 
                class="w3-check"
                v-model="filtrar_apenas_meus_clientes"
                id="verApenasMeusClientes"
              />
              <label :for="'verApenasMeusClientes'">Ver apenas meus clientes</label>
            </div> 

            <div class="w3-col s12 m12 l12 w3-left w3-margin-top" style="position: relative;">
              
              <div class=" w3-dropdown-hover w3-left">
                <button 
                  class="w3-button w3-theme">
                  <i class="fa fa-filter"></i>
                </button>
                
                <div class="w3-dropdown-content w3-bar-block w3-border" style="width: 210px;">
                  <button 
                    class="w3-bar-item w3-button botao-quadrado" 
                    @click="setChaveClientePesquisa('COD')">
                    <i :class="getIconeFiltroCliente('COD')"></i>
                    <span>Código</span>
                  </button>

                  <button 
                    class="w3-bar-item w3-button botao-quadrado" 
                    @click="setChaveClientePesquisa('NOM')">
                    <i :class="getIconeFiltroCliente('NOM')"></i>
                    <span>Nome</span>
                  </button>

                  <button 
                    class="w3-bar-item w3-button botao-quadrado" 
                    @click="setChaveClientePesquisa('CNP')">
                    <i :class="getIconeFiltroCliente('CNP')"></i>
                    <span>CPF/CNPJ</span>
                  </button>
                </div>
              </div>

              <div class="w3-dropdown-hover w3-left">
                
                <button 
                  style="margin-left: 5px;"
                  class="w3-button w3-blue-grey" 
                  v-on:click="abrirModalConfiguracoesFiltros()">
                  <i style="font-size: 18px;" class="fa fa-cog"/>
                  <i style="font-size: 10px;" class="fa fa-database"/>
                </button>

              </div>

              <div class="w3-right">
                <button 
                  class="w3-button w3-theme" 
                  v-on:click="adicionarClienteVerificandoDados(false)" 
                  :disabled="processando" 
                  v-if="mostrar_filtros_clientes">
                  <span>Pesquisar</span>
                </button>
              </div>                 
              
              <div 
                v-if="clientes_filtrados.length > 0 && !processando" 
                class="w3-col s12 m12 s12 w3-center" 
                style="margin-top: 1px;">
                <i
                  class='fas fa-caret-down'
                  @click="mostrar_filtros_clientes = false"
                  style='font-size:24px; cursor: pointer;'>
                </i> 
              </div>
            </div>

          </div>   
          <div class="w3-col s12 m12 l12 w3-left">
            <button 
              class="w3-bar-item w3-button w3-col w3-white w3-border w3-mobile" 
              v-if="!mostrar_filtros_clientes" 
              v-on:click="mostrar_filtros_clientes = !mostrar_filtros_clientes">
              <i class="fa fa-filter icone-vermelho"></i> Mostrar filtros
            </button>
          </div>             
        </div>

        <div 
          data-div="paginacao"
          class="w3-margin-top w3-container"
          v-if="(!mostrar_filtros_clientes) &&
          clientes_filtrados && 
          (clientes_filtrados.length > 0) &&
          (total_paginas > 1)">

          <button 
            data-button="botao-angle-left"
            class="w3-col w3-btn w3-theme s2 m1 menu-paginacao" 
            @click="pagina_atual = 1" 
            :disabled="pagina_atual == 1">
            <i data-i="botao-angle-left" class="fa fa-angle-double-left"></i>
          </button>
            
          <button 
            data-button="botao-angle-left"
            class="w3-col w3-btn w3-theme s2 m1 menu-paginacao" 
            @click="pagina_atual -= 1" 
            :disabled="pagina_atual == 1">
            <i data-i="botao-angle-left" class="fa fa-angle-left"></i>
          </button>
            
          <button 
            data-button="botao-angle-right"
            class="w3-col w3-btn w3-theme s2 m1 menu-paginacao" 
            @click="pagina_atual += 1" 
            :disabled="pagina_atual == total_paginas">
            <i data-i="botao-angle-right" class="fa fa-angle-right"></i>
          </button>
            
          <button
            data-button="botao-double-right" 
            class="w3-col w3-btn w3-theme s2 m1 menu-paginacao" 
            @click="pagina_atual = total_paginas" 
            :disabled="pagina_atual == total_paginas">
            <i data-i="botao-double-right" class="fa fa-angle-double-right"></i>
          </button>

          <strong 
            data-strong="numero-pagina"
            class="w3-right">
              {{pagina_atual}} / {{total_paginas}}
          </strong>
        </div>

        <div v-if="!mostrar_filtros_clientes">
          <div class="w3-col s12 w3-margin-top w3-margin-bottom">
            <div
              v-show="clientes_filtrados.length > 0" 
              class="w3-responsive w3-border w3-hide-small w3-hide-medium" 
              v-if="!mostrar_filtros_clientes && !processando_ver_mais" 
              style="max-height: calc(75vh - 300px);min-height: 200px;overflow: auto">
              
              <table class="w3-table-all">
                <thead>
                  <tr>
                    <th class="alinhamento-numero">Código</th>
                    <th class="alinhamento-texto">Nome</th>
                    <th class="alinhamento-texto">Nome fantasia</th>
                    <th class="alinhamento-texto" >CPF/CNPJ</th>
                    <th class="alinhamento-texto">Endereço</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    class="label-clicavel" 
                    :key="cliente.cadastro_id"
                    v-for="(cliente, indice) in clientes_filtrados" 
                    @click="adicionarCliente(cliente)"
                    v-show="(indice >= (pagina_atual * c_clientes_por_pagina) - c_clientes_por_pagina) && (indice < (pagina_atual * c_clientes_por_pagina))">

                    <td class="alinhamento-numero">{{cliente.cadastro_id}}</td>
                    <td class="alinhamento-texto">{{cliente.nome_razao_social}}</td>
                    <td class="alinhamento-texto">{{cliente.nome_fantasia}}</td>
                    <td class="alinhamento-texto" style="white-space: nowrap;" v-if="cliente.tipo_pessoa == 'F'">{{cliente.cpf}}</td>
                    <td class="alinhamento-texto" style="white-space: nowrap;" v-if="cliente.tipo_pessoa == 'J'">{{cliente.cnpj}}</td>
                    <td class="alinhamento-texto">{{cliente.nome_cidade}} / {{cliente.nome_bairro}} / {{cliente.logradouro}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="w3-hide-large" v-if="!processando_ver_mais">
              <div
                class="w3-container card-item w3-border"
                :key="cliente.cadastro_id" 
                v-for="(cliente, indice) in clientes_filtrados" 
                @click="adicionarCliente(cliente)"
                v-show="(indice >= (pagina_atual * c_clientes_por_pagina) - c_clientes_por_pagina) && (indice < (pagina_atual * c_clientes_por_pagina))">

                <div class="w3-col s12">
                  <label>{{cliente.cadastro_id}}</label>
                  <label> - </label>
                  <strong class="w3-text-theme">{{cliente.nome_razao_social}}</strong>
                </div>

                <div v-if="cliente.nome_fantasia != cliente.nome_razao_social" class="w3-col s12">
                  <strong>{{cliente.nome_fantasia}}</strong>
                </div>

                <div v-if="cliente.tipo_pessoa == 'F'" class="w3-col s12">
                  <strong>{{cliente.cpf}}</strong>
                </div>

                <div v-if="cliente.tipo_pessoa == 'J'" class="w3-col s12">
                  <strong>{{cliente.cnpj}}</strong>
                </div>

                <div class="w3-col s12" style="font-size: 12px;">
                  <label>{{cliente.nome_cidade}} / {{cliente.nome_bairro}} / {{cliente.logradouro}}</label>
                </div>
              </div>            
            </div>

            <div class="w3-col l12 w3-right w3-margin-top" v-if="mostrar_botao_ver_mais">
              <button 
                :disabled="processando_ver_mais"
                v-on:click="adicionarClienteVerificandoDados(true)"
                class="w3-button w3-theme w3-right">
                <span>Ver mais</span>
              </button>
            </div>

          </div>
        </div>
        <footer class="w3-container conteudo-centralizado"></footer>
      </div>
    </div>
    <!-- Fim modal de Cliente  --> 

    <div 
      class="w3-modal"
      style="display: block"
      id="modalConfiguracoesFiltro"
      v-if="abrir_modal_configuracoes_filtro">

      <div class="w3-modal-content w3-animate-zoom borda_modal">
        <div>
          <header class="w3-container">
            <span 
              class="w3-button w3-display-topright"
              @click="abrir_modal_configuracoes_filtro = false">&times;
            </span>
            <h4 class="texto-vermelho titulo">Configurações Filtros</h4>
          </header>

          <div class="w3-row-padding w3-margin-bottom">

            <div class="w3-col s12">
              <strong>Campo de pesquisa padrão</strong>
              <select class="w3-select w3-border" v-model="campo_padrao_pesquisa">
                <option :value="'COD'"> Código</option>
                <option :value="'NOM'"> Nome</option>
                <option :value="'CNP'"> CPF/CNPJ</option>
              </select>
            </div>

            <div class="w3-center w3-col s12" style="margin-top: 25px; margin-bottom:5px">
              <button 
                class="w3-button w3-theme"
                v-on:click="gravarConfiguracoesFiltros()"> 
                <i class="fas fa-database"></i> Gravar configurações
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
  import store from '@/ambiente/store'
  import legenda from '@/components/Legendas'
  import RSessao from '@/components/Rest/RSessao'
  import formatarValorMixin from '@/mixins/formatarValorMixin'
  import RCliente from '@/components/Rest/RCliente/RCliente.js'
  import ExibirProcessando from '@/components/ExibirProcessando'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import FinanceirosAbertoCliente from '@/components/FinanceirosAbertoCliente'

  export default {
    name: "FrameClienteOrcamento",
    
    components: {
      legenda,
      ExibirProcessando,
      FinanceirosAbertoCliente
    },

    mixins:[formatarValorMixin],

    props: {
      permitido_trocar_cliente: undefined, 
      carregar_direto: undefined,
      buscar_financeiros_aberto: undefined,
      verificarDados: {
        required: false,
        type: Function,
        default: function () {
          return true
        }
      },
    },
    
    data() {
      return {
        abrir_modal_selecionar_cliente: false,
        abrir_modal_configuracoes_filtro: false,
        clientes_filtrados: [],
        chave_cliente_pesquisa: '',
        chave_cliente_pesquisa_modal: '',
        cliente_selecionado: {},
        nome_cliente_exibicao: undefined,
        financeiros_abertos: undefined,
        processando: false,
        tipo_pesquisa: 'NOM',
        mostrar_filtros_clientes: true,
        adicionando_direto: false,
        placeholder_codigo: 'Cód.',
        total_financeiros_abertos: 0,
        ver_apenas_meus_clientes: 'N',
        filtrar_apenas_meus_clientes: false,

        c_clientes_por_pagina: 100,
        pagina_atual: 0,
        total_paginas: 0,

        mostrar_botao_ver_mais: false,
        processando_ver_mais: false,
        clientes_ja_mostrados_ids: [],

        localStorage: {},
        campo_padrao_pesquisa: '',
      }
    },

    watch: {
      abrir_modal_selecionar_cliente() {
        this.mostrar_filtros_clientes = true;       
        this.$nextTick(() => this.$refs.chave_pesquisa_cliente_ref.focus());
      },

      mostrar_filtros_clientes() {
        if (this.mostrar_filtros_clientes) {
          this.$nextTick(() => this.$refs.chave_pesquisa_cliente_ref.focus());
        }
      }
    },
    methods: {
      async inserirDadoPorChave(cadastro_id) {
        this.adicionando_direto = true;
        let chave_pesquisa = 0;

        if (Number.isInteger(cadastro_id)) {
          chave_pesquisa = cadastro_id;
        }
        else if (cadastro_id) {
          chave_pesquisa = cadastro_id.replace('.', '');
        }
        
        if (cadastro_id <= 0) {
          return;
        }

        await this.buscarCliente('COD', chave_pesquisa, false);
      },

      verificarCampoPesquisa: function(){
        if (!this.cliente_selecionado.cadastro_id){
          this.placeholder_codigo = 'Cód';
          this.chave_cliente_pesquisa = '';
        } else if (this.cliente_selecionado.cadastro_id != this.chave_cliente_pesquisa) {
          this.placeholder_codigo = this.cliente_selecionado.cadastro_id;
          this.chave_cliente_pesquisa = '';
        }
      },

      async exibirFinanceirosAbertos(){
        this.$refs.financeirosAbertoCliente.buscarFinanceirosAbertos(this.cliente_selecionado); 
      },

      adicionarPesquisando(ver_mais) {
        if 
          (
            (this.tipo_pesquisa == 'COD') && 
	          (
              (this.chave_cliente_pesquisa == '') ||
              (parseInt(this.chave_cliente_pesquisa) < 0)
            )
          )
        {
          Biblioteca.exclamar('Digite um código válido!');
          return;
        }

        this.adicionando_direto = true;
        this.tipo_pesquisa = 'COD';
        
        this.buscarCliente(this.tipo_pesquisa, this.chave_cliente_pesquisa.replace('.', ''), false, ver_mais);
        this.tipo_pesquisa = 'NOM';
      },

      verificarErro(erro, nome_funcao){
        this.finalizarProcessando();
        this.clientes_filtrados = [];
        Biblioteca.gerarLogNomeFuncao('FrameClienteOrcamento.vue ->' + nome_funcao);
        let mensagem = Biblioteca.tratamentoMensagem(erro);
        Biblioteca.exclamar(mensagem);
      },

      finalizarProcessando(){
        this.processando = false;
        this.processando_ver_mais = false;
        this.adicionando_direto = false;
      },

      async buscarCliente(tipo, chave, filtrar_apenas_meus_clientes, ver_mais) {
        try {
          if (this.carregar_direto && ver_mais) {
            Biblioteca.exclamar('Não é permitido carregar o pedido com a opção ver_mais ativa!');
            return;
          }

          if (ver_mais) {
            this.processando_ver_mais = true;
          }
          else {
            this.processando = true;
            this.clientes_filtrados = [];
            this.clientes_ja_mostrados_ids = [];
          }

          let parametros = {
            tipo: tipo,
            chave: chave,
            filtrar_apenas_meus_clientes: filtrar_apenas_meus_clientes ? 'S': 'N'
          }

          if (this.clientes_ja_mostrados_ids && this.clientes_ja_mostrados_ids.length > 0 && ver_mais) {
            parametros.clientes_ja_mostrados_ids = JSON.parse(JSON.stringify(this.clientes_ja_mostrados_ids));
          }

          let retorno = await RCliente.pesquisarClientesOrcamento(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          for (let i = 0; i < this.clientes_filtrados.length; i++) {
            this.clientes_filtrados[i].primeiro_item_pagina = false;
          }

          let primeiro_item_pagina = true
          for (let i = 0; i < retorno.dados.clientes.length; i++) {
            retorno.dados.clientes[i].primeiro_item_pagina = primeiro_item_pagina;
            primeiro_item_pagina = false;

            this.clientes_filtrados.push(JSON.parse(JSON.stringify(retorno.dados.clientes[i])));
            this.clientes_ja_mostrados_ids.push(retorno.dados.clientes[i].cadastro_id);
          }

          if (this.carregar_direto || this.adicionando_direto) {
            await this.adicionarCliente(this.clientes_filtrados[0]);
          }
          else if (ver_mais) {
            this.pagina_atual++;           
          }
          else {
            this.pagina_atual = 1;
          }

          this.total_paginas = Math.ceil(this.clientes_filtrados.length / this.c_clientes_por_pagina);

          this.mostrar_filtros_clientes = false;
          this.mostrar_botao_ver_mais = retorno.dados.tem_continuacao == 'S';
        
          this.finalizarProcessando();
        } catch (error) {
          this.verificarErro(error, 'buscarCliente');   
        }
      },

      async adicionarCliente(cliente) {
        try {

          let parametros = {
            cadastro_id: cliente.cadastro_id
          }  
          
          let retorno = await RCliente.buscarDadosCompletoCliente(this.axios, parametros);       

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          let cliente_completo = JSON.parse(JSON.stringify(retorno.dados))
          
          if (!this.verificarDados(cliente_completo)) {
            return;
          }

          this.carregar(cliente_completo);
          this.abrir_modal_selecionar_cliente = false;
          this.$emit('cliente_selecionado', this.cliente_selecionado);
        } catch (error) {
          this.verificarErro(error, 'adicionarCliente');   
        }
      },

      carregar(cliente){
        this.chave_cliente_pesquisa = '';
        this.cliente_selecionado = JSON.parse(JSON.stringify(cliente));
        this.placeholder_codigo = this.cliente_selecionado.cadastro_id;
        this.nome_cliente_exibicao = this.cliente_selecionado.nome_razao_social;
      },

      adicionarClienteVerificandoDados(ver_mais) {
        let tipo_pesquisa_temp = this.tipo_pesquisa;
        let chave_cliente_pesquisa_temp = this.chave_cliente_pesquisa_modal;

        if (this.tipo_pesquisa == 'COD') {
          if ((chave_cliente_pesquisa_temp == '') || (parseInt(chave_cliente_pesquisa_temp) < 0)) {
            Biblioteca.exclamar('Digite um código válido!!');
            return;
          }        

          if
	        (
            (this.tipo_pesquisa == 'COD') &&
            (parseInt(chave_cliente_pesquisa_temp) < 0) &&
            (parseInt(chave_cliente_pesquisa_temp) > 999999999)
          ) 
          {
            Biblioteca.exclamar('Digite um código válido!');
            return;
          }
        }
        
        if (this.tipo_pesquisa == 'NOM') {
          if (chave_cliente_pesquisa_temp.length < 3) {
            Biblioteca.exclamar('É necessário digitar no mínimo 3 caracteres de pesquisa!');
            return;
          }

          let somente_caracter_coringa = true
          for (let i = 0; i < this.chave_cliente_pesquisa_modal.length; i++) {
            somente_caracter_coringa = (this.chave_cliente_pesquisa_modal[i] == '%');

            if (!somente_caracter_coringa) {
              break;
            }
          }

          if (somente_caracter_coringa) {
            Biblioteca.exclamar('Este tipo de pesquisa não permite utilizar somente caracteres coringa!');
            return;
          }
        }

        if (this.tipo_pesquisa == 'CNP') {
          if (chave_cliente_pesquisa_temp.length > 18) {
            Biblioteca.exclamar('Informe no máximo 18 caracteres nesta opção de pesquisa!');
            return;
          } 
  
          if (chave_cliente_pesquisa_temp.length <= 10) {
            tipo_pesquisa_temp = 0;
          }

          chave_cliente_pesquisa_temp = chave_cliente_pesquisa_temp.replace(/[\/.-]/g, '');
        }

        this.buscarCliente(tipo_pesquisa_temp, chave_cliente_pesquisa_temp.replace('.', ''), this.filtrar_apenas_meus_clientes, ver_mais);
      },

      async utilizaGerenciamentoCarteira(){        
        let buscou_dados_sessao = await RSessao.carregouSessao();
        
        if (!buscou_dados_sessao){
          await RSessao.buscarDadosCarregarSessao(this.axios);         
        }

        this.ver_apenas_meus_clientes = await store.state.usuario_logado.utiliza_gerenciamento_carteiras;
        this.filtrar_apenas_meus_clientes = this.ver_apenas_meus_clientes == 'S' ? true : false;
      },

      limparDados() {
        Object.assign(this.$data, this.$options.data.apply(this));
        this.$emit('limpar_cliente');
      },

      setChaveClientePesquisa(sigla) {
        this.tipo_pesquisa = sigla;
        this.chave_cliente_pesquisa_modal = '';
      },

      getIconeFiltroCliente(sigla) {
        if(sigla == this.tipo_pesquisa) {
          return 'fa fa-check-square icone-vermelho';
        }
        else {
          return 'far fa-square';
        }
      },

      descricaoTipoPesquisa(sigla) {
        if (sigla == 'COD') {
          return 'Código';
        }
        else if (sigla == 'NOM') {
          return 'Nome';
        }
        else if (sigla == 'CNP') {
          return 'CPF/CNPJ';
        }
      },

      estiloBotaoCredito(){
        if (this.buscar_financeiros_aberto)
          return 'label-cliente w3-right link';
        else 
          return 'label-cliente w3-right';
      },

      async gravarConfiguracoesFiltros(){
        try {

          let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'));

          if (!armazenamentoLocalStorage){
            armazenamentoLocalStorage = {};
          }

          let configuracoes_dispositivo_offline = armazenamentoLocalStorage.configuracoes_dispositivo_offline;

          if (!configuracoes_dispositivo_offline){
            configuracoes_dispositivo_offline = {};
          }

          configuracoes_dispositivo_offline.pesquisa_cliente_orcamento = {
            campo_padrao_pesquisa: this.campo_padrao_pesquisa
          }

          armazenamentoLocalStorage.configuracoes_dispositivo_offline = configuracoes_dispositivo_offline;
          
          await localStorage.setItem('localStorage', JSON.stringify(armazenamentoLocalStorage)); 
          await this.buscarFiltrosDefinidosLocalStorage();
          
          this.abrir_modal_configuracoes_filtro = false; 
        } catch (error) {
          this.verificarErro(error, 'gravarConfiguracoesFiltros');     
        }
      },

      async buscarFiltrosDefinidosLocalStorage(){
        try {
          let campo_padrao_definido = this.tipo_pesquisa;
          let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'));

          if 
            (
              armazenamentoLocalStorage &&
              armazenamentoLocalStorage.configuracoes_dispositivo_offline && 
              armazenamentoLocalStorage.configuracoes_dispositivo_offline.pesquisa_cliente_orcamento
            )
          {
            let filtros = armazenamentoLocalStorage.configuracoes_dispositivo_offline.pesquisa_cliente_orcamento;
            if (filtros.campo_padrao_pesquisa){
              campo_padrao_definido = filtros.campo_padrao_pesquisa; 
            }
          }

          await this.setChaveClientePesquisa(campo_padrao_definido);
        } catch (error) {
          this.verificarErro(error, 'buscarFiltrosDefinidosLocalStorage');      
        }
      },

      async abrirModalConfiguracoesFiltros(){
        try {
          this.campo_padrao_pesquisa = 'NOM';
          let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'))

          if 
            (
              armazenamentoLocalStorage &&
              armazenamentoLocalStorage.configuracoes_dispositivo_offline && 
              armazenamentoLocalStorage.configuracoes_dispositivo_offline.pesquisa_cliente_orcamento
            )
          {
            let filtros = armazenamentoLocalStorage.configuracoes_dispositivo_offline.pesquisa_cliente_orcamento;
            if (filtros.campo_padrao_pesquisa){
              this.campo_padrao_pesquisa = filtros.campo_padrao_pesquisa; 
            }
          }

          this.abrir_modal_configuracoes_filtro = true; 
        } catch (error) {
          this.verificarErro(error, 'abrirModalConfiguracoesFiltros');      
        }
      },
      onBlurChave() {
        console.log("onBlurChave cliente");
        if (this.chave_cliente_pesquisa) {
          console.log("chave_cliente_pesquisa: " + this.chave_cliente_pesquisa);
          if (this.cliente_selecionado.cadastro_id ) {
            console.log("verificando se a chave e igual ao cliente atual");
            if (this.cliente_selecionado.cadastro_id != this.valorInt(this.chave_cliente_pesquisa)) {
              console.log("verificando se a chave diferente limpando e buscando");
              this.adicionarPesquisando(false);
            }
          }
          else {
            console.log("sem vendedor prequisando com chave : " + this.chave_pesquisa);
            this.adicionarPesquisando(false);
          }
        }

      },
      valorInt(numero) {
        return Biblioteca.valorInt(numero);
      }
    },
    
    async created(){
      await this.utilizaGerenciamentoCarteira();
      await this.buscarFiltrosDefinidosLocalStorage();
    }
  }
</script>

<style escoped>
  .card-item {
    background-color: #f3f3f3;
    border-radius: 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    margin-bottom: 5px;
    padding: 3px !important;
  }

  .input-codigo-cliente {
    padding: 10px 15px;
    border-radius: 0px;
    position: relative;
    z-index: 0;
    background: #fff;
    font-weight: bold;
  }

  .input-container {
    display: -ms-flexbox; 
    display: flex;
    position: relative;
    z-index: 1;
    margin-left: -20px;
    width: calc(100% + 20px);
  }

  .icone {
    padding: 11px;
    background: gray;
    color: white;
    min-width: 15px;
    text-align: center;
    border-left-style: none
  }

  .icone:active {
    background-color: #ccc;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  .input-cliente {
    width: 100%;
    padding: 10px;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    border-right-style: none;
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%
  }

  .card-financeiro-aberto:hover {
    background: #ededed;
  }

  .card-financeiro-aberto {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 !important;
    background: #ffffff;
    color:#4f4f4f;
  }

  .texto-financeiro {
    margin:0; 
    padding:0; 
    font-size:12px; 
    font-weight:bold;
  }

  .link{
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline; 
    color: #335696;
  }

</style>





// WEBPACK FOOTER //
// src/components/Frames/FrameClienteOrcamento.vue